import { render, staticRenderFns } from "./result-quiz.vue?vue&type=template&id=71aaefde&scoped=true&"
import script from "./result-quiz.vue?vue&type=script&lang=js&"
export * from "./result-quiz.vue?vue&type=script&lang=js&"
import style0 from "./result-quiz.vue?vue&type=style&index=0&id=71aaefde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aaefde",
  null
  
)

export default component.exports